import React from 'react';
import { styled } from '@mui/material/styles';
import Check from '@mui/icons-material/Check'; // Import the Check icon

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 40,
  height: 40,
  fontWeight: 700,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    background: `linear-gradient(136deg, #4AAE9B 0%, #4AAE9B 100%)`,
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.25)',
  }),
  ...(ownerState.completed && {
    background: `linear-gradient(136deg,rgb(129, 197, 185) 0%, rgb(129, 197, 185) 100%)`,
    boxShadow: '0 2px 5px #C9BAAC',
}),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {
        completed ? <Check className="QontoStepIcon-completedIcon" /> : icon
      }
        
    </ColorlibStepIconRoot>
  );
}

export default ColorlibStepIcon;